import { args } from '../../common/args';
import { defineCapability } from '../internal';
export const TRACK_WIDGET_INTERACTION_CAP = defineCapability({
  name: 'TRACK_WIDGET_INTERACTION_CAP',
  args: {
    eventTargetId: args.string(),
    action: args.string(),
    widget: args.string(),
    widgetSubtype: args.optional(args.string()),
    destinationUrl: args.optional(args.string()),
    eventData: args.optional(args.anyObject())
  }
});